import Home from "./Views/Home";

// Disable right click
document.addEventListener("contextmenu", (event) => event.preventDefault());

function App() {
  return (
    // Styles applied to all elements
    <div>
      <Home />
    </div>
  );
}

export default App;
